module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 // Declare all variables to be used by the svg shapes ;
__p += '\n';
 var cx = 0; ;
__p += '\n';
 var cy = 0; ;
__p += '\n';
 var rx = 0; ;
__p += '\n';
 var ry = 0; ;
__p += '\n';
 var x1 = 0; ;
__p += '\n';
 var x2 = 0; ;
__p += '\n';
 var y1 = 0; ;
__p += '\n';
 var y2 = 0; ;
__p += '\n\n';
 // Volume comes in L, calculations based off of mL ;
__p += '\n';
 volume = parseInt(Math.floor(volume*1000)); ;
__p += '\n\n';
 if (!pour){ ;
__p += '\n';
     // Upright flask ;
__p += '\n';
     y1 = 130.238-(0.0711429*volume); ;
__p += '\n';
     x1 = -((y1-186.519)/3.55825); ;
__p += '\n';
     x2 = (y1+240.918)/3.57862; ;
__p += '\n';
     ry = (.0683818*y1)+1.00976; ;
__p += '\n';
     rx = (.294185*y1)+5.82938; ;
__p += '\n';
     cx = 60; ;
__p += '\n';
     cy = y1; ;
__p += '\n';
 } else { ;
__p += '\n';
     // Tilted flask ;
__p += '\n';
     cx = (.0000501834*Math.pow(volume, 2))-(.105231*volume)+145.061; ;
__p += '\n';
     cy = ((2.4955*Math.pow(10, -8))*(Math.pow(volume, 3)))-(.0000311744*Math.pow(volume, 2))-(.00957964*volume)+77.5209; ;
__p += '\n';
     if (volume < 100){rx=2;}else{rx=4;} ;
__p += '\n';
     ry = (-.000047707*Math.pow(volume,2))+(.0908388*volume)+10.2698; ;
__p += '\n';
     x1 = 100.087-(.0867824*volume); ;
__p += '\n';
     y1 = 142.692-(.0769231*x1); ;
__p += '\n';
     x2 = 103.033-(.0333778*volume); ;
__p += '\n';
     y2 = (3.08*x2)-197.24; ;
__p += '\n';
 } ;
__p += '\n\n<svg\nxmlns:dc="http://purl.org/dc/elements/1.1/"\nxmlns:cc="http://creativecommons.org/ns#"\nxmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\nxmlns:svg="http://www.w3.org/2000/svg"\nxmlns="http://www.w3.org/2000/svg"\nversion="1.1"\nwidth="120"\nheight="150">\n\n  ';
 ///////// No Fill //////////// ;
__p += '\n\n  <g\n  ';
 if (volume <= 0){ ;
__p += '\n  ' +
((__t = (   'style="display:none"' )) == null ? '' : __t) +
'\n  ';
 } else { ;
__p += '\n  ' +
((__t = (   'style="display:auto"' )) == null ? '' : __t) +
'\n  ';
 } ;
__p += '\n  >\n\n  ';
 //////// Liquid Fill On Upright Flask ////// ;
__p += '\n\n  <g id="fill"\n  ';
 if (!pour){ ;
__p += '\n  ' +
((__t = (   'style="display:auto"' )) == null ? '' : __t) +
'\n  ';
 } else { ;
__p += '\n  ' +
((__t = (   'style="display:none"' )) == null ? '' : __t) +
'\n  ';
 } ;
__p += '\n  >\n    <g\n    id="opaque"\n    style="opacity:.6"\n    >\n\n      <ellipse\n      id="bottomCircle"\n      cx="60"\n      cy="131"\n      rx="44.5"\n      ry="14.5"\n      style="fill:' +
((__t = (color )) == null ? '' : __t) +
'"\n      />\n\n      <polygon\n      id="fill"\n      points="16, 130, 105, 130, ' +
((__t = ( x2 )) == null ? '' : __t) +
', ' +
((__t = ( y1 )) == null ? '' : __t) +
', ' +
((__t = ( x1 )) == null ? '' : __t) +
', ' +
((__t = ( y1 )) == null ? '' : __t) +
'"\n      style="fill:' +
((__t = (color )) == null ? '' : __t) +
'"\n      />\n\n    </g>\n\n    <ellipse\n      id="topCircle"\n      cx="60"\n      cy="' +
((__t = ( cy )) == null ? '' : __t) +
'"\n      rx="' +
((__t = ( rx )) == null ? '' : __t) +
'"\n      ry="' +
((__t = ( ry )) == null ? '' : __t) +
'"\n      style="fill:' +
((__t = (color )) == null ? '' : __t) +
'"\n    />\n  </g>\n\n\n';
 //////// Liquid Fill On Tilted Flask ////// ;
__p += '\n\n  <g\n  ';
 if (pour){ ;
__p += '\n  ' +
((__t = (   'style="display:auto"' )) == null ? '' : __t) +
'\n  ';
 } else { ;
__p += '\n  ' +
((__t = (   'style="display:none"' )) == null ? '' : __t) +
'\n  ';
 } ;
__p += '\n  >\n\n    <g\n    id="opaque"\n    style="opacity:.6"\n    >\n\n    <polygon\n      id = "pourFill"\n      points="\n      ' +
((__t = (cx)) == null ? '' : __t) +
', ' +
((__t = (cy-ry)) == null ? '' : __t) +
',\n      145, 67,\n      149, 73,\n      150, 78,\n      149, 82,\n      145, 87,\n      ' +
((__t = (cx)) == null ? '' : __t) +
', ' +
((__t = (cy+ry)) == null ? '' : __t) +
'"\n      style="fill:' +
((__t = (color)) == null ? '' : __t) +
';-webkit-transform: rotate(25deg);"\n      />\n  </g>\n\n\n    <ellipse\n      id="pourCircleTop"\n      cx="' +
((__t = ( cx )) == null ? '' : __t) +
'"\n      cy="' +
((__t = ( cy )) == null ? '' : __t) +
'"\n      rx="' +
((__t = ( rx )) == null ? '' : __t) +
'"\n      ry="' +
((__t = ( ry )) == null ? '' : __t) +
'"\n      style="fill:' +
((__t = (color)) == null ? '' : __t) +
';-webkit-transform: rotate(25deg);"/>\n  </g>\n</g>\n\n';
 ////////// Flask Linework ///////////////// ;
__p += '\n\n  <g>\n    <g transform="translate(-138.21429,-45.031211)">\n      <g transform="translate(254.67144,-25.849258)">\n        <g\n           transform="matrix(0.2702268,0,0,0.28033518,-134.30076,21.695822)"\n           style="display:inline">\n          <g>\n            <path\n               d="m 316.52075,218.88846 c 9.47145,0.68601 16.03615,0.49156 26.18545,2.15266 5.11765,0.83758 8.99801,3.05813 8.99801,3.38122"\n               style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none" />\n            <path\n               d="m 215.58617,226.22564 c 7.36623,-3.10901 1.37075,-0.73588 10.3287,-3.69309 12.69828,-2.7397 26.66283,-3.92833 48.59432,-4.74076 10.89094,-0.40774 16.30102,-0.0845 29.76551,0.40465"\n               style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none" />\n            <path\n               d="m 345.84856,595.98033 c -17.68682,-1.90703 -36.80505,-2.95636 -56.77074,-2.95636 -66.67545,0 -124.02218,11.62127 -149.4683,28.28615"\n               style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n            <path\n               d="m 438.54613,621.31012 c -8.77099,-5.74392 -21.33437,-10.88789 -36.76172,-15.16503"\n               style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n          </g>\n        </g>\n        <g\n           style="display:inline">\n          <g\n             transform="matrix(0.2702268,0,0,0.28033518,-80.442714,27.826378)">\n            <g\n               transform="translate(-60.630762,-9.3833322)">\n              <path\n                 d="m 213.83427,221.79664 c -9.72729,6.92777 -20.55526,10.29531 -37.84319,12.62429 -21.01466,2.22699 -37.81187,2.95738 -61.9376,0.35856"\n                 style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none" />\n              <path\n                 d="M 19.949885,656.80126 C -2.2627144,646.07876 -7.3473845,632.48772 -7.3473845,621.01701"\n                 style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n              <path\n                 d="m 305.55323,621.01701 c 0,22.94143 -20.1995,54.36071 -156.26496,54.36071 -46.84664,0 -79.958535,-3.7251 -103.239855,-9.54543"\n                 style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n              <path\n                 d="m 80.040645,220.70304 c 6.3714,1.85833 3.46428,0.85208 12.661915,3.13457 13.24725,3.28771 31.54796,5.32086 51.76272,5.32086 29.64874,0 53.32037,-4.6294 64.88346,-10.69596 2.79135,-1.4645 4.31656,-3.46058 4.6141,-4.90469"\n                 style="fill:none;stroke:#161413;stroke-width:2.28114033;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none" />\n              <g\n                 transform="matrix(1.1405702,0,0,1.1405702,36.670645,289.59468)">\n                <path\n                   d="m 122.54132,193.64923 c 10.554,-0.57993 20.37559,-1.52502 29.2688,-2.80142"\n                   style="fill:none;stroke:#161413;stroke-width:3;stroke-linecap:round;stroke-linejoin:round" />\n                <path\n                   d="m 124.3292,234.39746 c 10.554,-0.57993 20.37559,-1.52502 29.2688,-2.80142"\n                   style="fill:none;stroke:#161413;stroke-width:3;stroke-linecap:round;stroke-linejoin:round" />\n                <path\n                   d="m 125.13875,268.80371 c 10.554,-0.57993 20.37559,-1.52502 29.2688,-2.80142"\n                   style="fill:none;stroke:#161413;stroke-width:3;stroke-linecap:round;stroke-linejoin:round" />\n                <path\n                   d="m 120.68618,144.53643 c 10.554,-0.57993 20.37559,-1.52502 29.2688,-2.80142"\n                   style="fill:none;stroke:#161413;stroke-width:3;stroke-linecap:round;stroke-linejoin:round" />\n                <path\n                   d="m 118.66229,76.533487 c 10.554,-0.57993 20.37559,-1.52502 29.2688,-2.80142"\n                   style="fill:none;stroke:#161413;stroke-width:3;stroke-linecap:round;stroke-linejoin:round" />\n              </g>\n            </g>\n            <path\n               d="m 22.991526,484.86676 c -225.836986,411.0048 -112.918492,205.5024 0,0 z m -0.0011,-1.96292 c -225.836226,412.31342 -112.918112,206.15671 0,0 z"/>\n            <path\n               d="m 21.991766,218.48142 c 13.687353,3.58962 20.941073,5.69474 22.346253,6.04261"\n               style="fill:none;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n            <path\n               d="m 90.657219,523.58124 c -0.15975,6.42284 -5.74922,12.29762 -12.50855,12.7764 -21.28629,1.51737 -42.69397,0.62208 -63.795393,-2.67864 -6.7009099,-1.04403 -11.9628098,-7.37583 -11.8030498,-13.79867 0.17005,-6.83675 0.34007,-13.67235 0.51009,-20.50796 0.15995,-6.43083 5.6821398,-10.51831 12.3819198,-9.47429 21.100273,3.30068 42.509103,4.196 63.795393,2.67863 6.75816,-0.47766 12.0896,4.06689 11.92968,10.49657 -0.17002,6.83561 -0.34007,13.67236 -0.51009,20.50796 z"\n               style="fill:#1a1a1a;stroke:#161413;stroke-width:1.14057016;stroke-linecap:round;stroke-linejoin:round" />\n          </g>\n          <path\n             d="m -37.537193,90.861713 0,23.980647 25.430315,85.00981 c 0,6.28228 -5.711173,16.81426 -44.183202,16.81426 -38.471734,0 -44.18322,-10.53166 -44.18322,-16.81426 l 24.409522,-85.00981 0,-23.980647 c -0.06897,-5.50934 -1.673317,-3.61225 -1.864545,-6.84059 -0.05075,-1.91497 12.246213,-3.15922 20.226759,-3.15833 7.980547,8.2e-4 0.256921,1.3e-4 0.384379,2.8e-4 15.715391,0.0283 20.776657,1.32313 20.775237,3.19875 -0.176738,3.30198 -0.995245,0.0892 -0.995245,6.79981 z"\n             style="fill:none;stroke:#161413;stroke-width:1.25569749;stroke-linecap:round;stroke-linejoin:round" />\n        </g>\n      </g>\n    </g>\n  </g>\n</svg>\n\n<div class="vesselInfo"\n';
 if (!pour){ ;
__p += '\n' +
((__t = (   'style="text-align:center;margin-left:-15px;width:150%"' )) == null ? '' : __t) +
'\n';
 } else { ;
__p += '\n' +
((__t = (   'style="text-align:center;margin-left:-40px;"' )) == null ? '' : __t) +
'\n';
 } ;
__p += '\n>\n  <div class = "vesselName">\n    ' +
((__t = (name)) == null ? '' : __t) +
' <br>\n  </div>\n  <div class = "vesselStats">\n    ' +
((__t = (volume)) == null ? '' : __t) +
' <small>mL @</small> ' +
((__t = ( temperature.toFixed(3) )) == null ? '' : __t) +
' K</sub>\n  </div>\n</div>\n';

}
return __p
}